export default __webpack_public_path__ + "static/media/no-packing.328da723.svg";